import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import GeometryFactory from '../../geom/GeometryFactory';
import Coordinate from '../../geom/Coordinate';
import ArrayList from '../../../../../java/util/ArrayList';
var OffsetSegmentString = /*#__PURE__*/function () {
  function OffsetSegmentString() {
    _classCallCheck(this, OffsetSegmentString);
    OffsetSegmentString.constructor_.apply(this, arguments);
  }
  _createClass(OffsetSegmentString, [{
    key: "getCoordinates",
    value: function getCoordinates() {
      var coord = this._ptList.toArray(OffsetSegmentString.COORDINATE_ARRAY_TYPE);
      return coord;
    }
  }, {
    key: "setPrecisionModel",
    value: function setPrecisionModel(precisionModel) {
      this._precisionModel = precisionModel;
    }
  }, {
    key: "addPt",
    value: function addPt(pt) {
      var bufPt = new Coordinate(pt);
      this._precisionModel.makePrecise(bufPt);
      if (this.isRedundant(bufPt)) return null;
      this._ptList.add(bufPt);
    }
  }, {
    key: "reverse",
    value: function reverse() {}
  }, {
    key: "addPts",
    value: function addPts(pt, isForward) {
      if (isForward) for (var i = 0; i < pt.length; i++) this.addPt(pt[i]);else for (var _i = pt.length - 1; _i >= 0; _i--) this.addPt(pt[_i]);
    }
  }, {
    key: "isRedundant",
    value: function isRedundant(pt) {
      if (this._ptList.size() < 1) return false;
      var lastPt = this._ptList.get(this._ptList.size() - 1);
      var ptDist = pt.distance(lastPt);
      if (ptDist < this._minimimVertexDistance) return true;
      return false;
    }
  }, {
    key: "toString",
    value: function toString() {
      var fact = new GeometryFactory();
      var line = fact.createLineString(this.getCoordinates());
      return line.toString();
    }
  }, {
    key: "closeRing",
    value: function closeRing() {
      if (this._ptList.size() < 1) return null;
      var startPt = new Coordinate(this._ptList.get(0));
      var lastPt = this._ptList.get(this._ptList.size() - 1);
      if (startPt.equals(lastPt)) return null;
      this._ptList.add(startPt);
    }
  }, {
    key: "setMinimumVertexDistance",
    value: function setMinimumVertexDistance(minimimVertexDistance) {
      this._minimimVertexDistance = minimimVertexDistance;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._ptList = null;
      this._precisionModel = null;
      this._minimimVertexDistance = 0.0;
      this._ptList = new ArrayList();
    }
  }]);
  return OffsetSegmentString;
}();
export { OffsetSegmentString as default };
OffsetSegmentString.COORDINATE_ARRAY_TYPE = new Array(0).fill(null);